import {
  BANNER_DESCRIPTION_MAX_LENGTH,
  BANNER_TITLE_MAX_LENGTH,
  PERFECT_STORE_IMAGE_DIMENSIONS,
  PERFECT_STORE_IMAGE_MAX_SIZE_BYTES,
  RACK_TEXT_MAX_LENGTH
} from '@/utils/constants/perfectStoreConstants';

export const STRING_SCHEMA = {type: 'string'};

const REQUIRED_RULE = {type: 'required', msg: ' is required'};

const maxLengthRule = (limit) => ({
  type: 'maxLength',
  limit,
  msg: ` must be less than or equal to ${limit} characters`
});

export const bannerImageHelperText = `PNG | JPG | WebP | ${PERFECT_STORE_IMAGE_DIMENSIONS.width} x ${PERFECT_STORE_IMAGE_DIMENSIONS.height}px | RGB Color | 3:1 Safe Area for Thumbnail | Max ${PERFECT_STORE_IMAGE_MAX_SIZE_BYTES / 1024}KB | With or without background`;

export const rackImageHelperText = bannerImageHelperText;

export const rackTextTooltipText = `Max ${RACK_TEXT_MAX_LENGTH} characters`;
export const bannerTitleTooltipText = `Max ${BANNER_TITLE_MAX_LENGTH} characters`;
export const bannerDescriptionTooltipText = `Max ${BANNER_DESCRIPTION_MAX_LENGTH} characters`;

export const bannerTitleUiSchema = {
  label: 'Title*',
  placeholder: 'Type here',
  isDark: true,
  tooltipText: bannerTitleTooltipText,
  maxLength: BANNER_TITLE_MAX_LENGTH,
  validationRules: [REQUIRED_RULE, maxLengthRule(BANNER_TITLE_MAX_LENGTH)]
};

export const bannerDescriptionUiSchema = {
  label: 'Description*',
  placeholder: 'Type here',
  isDark: true,
  showToolbar: false,
  tooltipText: bannerDescriptionTooltipText,
  rows: 5,
  maxLength: BANNER_DESCRIPTION_MAX_LENGTH,
  validationRules: [REQUIRED_RULE, maxLengthRule(BANNER_DESCRIPTION_MAX_LENGTH)]
};

export const rackHeaderUiSchema = {
  label: 'Header*',
  placeholder: 'Type here',
  isDark: true,
  showToolbar: false,
  tooltipText: rackTextTooltipText,
  maxLength: RACK_TEXT_MAX_LENGTH,
  validationRules: [REQUIRED_RULE, maxLengthRule(RACK_TEXT_MAX_LENGTH)]
};

export const rackSubHeaderUiSchema = {
  label: 'Sub header*',
  placeholder: 'Type here',
  isDark: true,
  showToolbar: false,
  tooltipText: rackTextTooltipText,
  maxLength: RACK_TEXT_MAX_LENGTH,
  validationRules: [REQUIRED_RULE, maxLengthRule(RACK_TEXT_MAX_LENGTH)]
};
